import { MediaObject } from 'types'

const ACCEPTABLE_RATIOS: ReadonlyArray<number> = [0.75, 0.8, 1, 1.91]
const DEFAULT_RATIO = ACCEPTABLE_RATIOS[0]

export const calculateAspectRatio = (mediaObject: MediaObject): number => {
  if (!mediaObject.width || !mediaObject.height) {
    return DEFAULT_RATIO
  }

  const actualRatio = mediaObject.width / mediaObject.height

  let closestRatio = DEFAULT_RATIO
  let smallestDifference = Math.abs(actualRatio - closestRatio)

  for (const acceptableRatio of ACCEPTABLE_RATIOS) {
    const difference = Math.abs(actualRatio - acceptableRatio)
    if (difference < smallestDifference) {
      smallestDifference = difference
      closestRatio = acceptableRatio
    }
  }

  return closestRatio
}

// Design graphics are composed at exact dimensions, so they must be shown in
// full (object-fit: contain) rather than cropped to a uniform carousel ratio.
// Unlike uploaded photos, they carry a design_key/frame_id and no width/height.
export const isDesignMediaObject = (mediaObject: MediaObject): boolean =>
  Boolean(mediaObject.design_key || mediaObject.frame_id)
